
@if (transportList().length > 0) {
  <div [class]="'points__transport-list-icons-overflow-wrapper' + ' ' + status()">
    <div class="points__transport-list-icons-overflow">
      @for (transport of transportList(); track transport.id; let i = $index) {
        <ci-icon
          [class]="'content__icon' + ' ' + transport.iconName"
          [name]="transport.iconName"
          type="svg"
        ></ci-icon>
      }
    </div>
    
    <button 
      class="ci-caption-regular points__transport-list-see-all-transports"
      (click)="handleClickOverflowTransportList()"
    >
      {{ 'Ver transportes' | translate }}
    </button>
  </div>
}